<template>
    <ContentPage title="Gebühren - Käufer">
        <div>
            <p>
                Sofern nicht schriftlich anders vereinbart oder in den besonderen Auktionsbedingungen anders angegeben, sind die vom Käufer an
                Fleequid zu zahlenden Gebühren für den Kauf und Verkauf jedes einzelnen Fahrzeugs über den Marktplatz oder die Kauf- und
                Verkaufsdienste und -systeme von Fleequid wie folgt:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> ohne MwSt.</p>
            <p><strong>**</strong> zzgl. MwSt., falls zutreffend</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Beispiel 1:</p>
            <p>Zuschlagspreis: 6.000&nbsp;€ +&nbsp;MwSt.</p>
            <p>
                Vom Käufer an Fleequid zu zahlende Gebühr: <br class="md:hidden" />
                <span class="font-medium">
                    Festbetrag von 250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;MwSt.</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Beispiel 2:</p>
            <p>Zuschlagspreis: 180.000&nbsp;€ +&nbsp;MwSt.</p>
            <p>
                Vom Käufer an Fleequid zu zahlende Gebühr: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;MwSt.</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
